import { useEffect, useState } from "react";
import { KEYS, load, save } from "@/lib/storage";

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    const saved = load(KEYS.theme);
    if (saved) return saved;
    if (typeof window !== "undefined" && window.matchMedia) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    save(KEYS.theme, theme);
  }, [theme]);

  return { theme, setTheme, toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")) };
}
